import { IDictionary } from "@common/models";

export const Locale: IDictionary<string> = {
    fa: "fa-IR",
    en: "en-US",
    ru: "ru"
}